import api from './api';

const CLASS_API_PATH = '/classes';

export const getAllClasses = async () => {
    try {
        const response = await api.get(CLASS_API_PATH);
        return response.data;
    } catch (error) {
        console.error("Error fetching classes:", error);
        throw error;
    }
};

// Public, unauthenticated list (id, name only) for the admission portal.
export const getPublicClassList = async () => {
    try {
        const response = await api.get(`${CLASS_API_PATH}/public/list`);
        return response.data;
    } catch (error) {
        console.error("Error fetching public class list:", error);
        throw error;
    }
};

export const createClass = async (name) => {
    try {
        const response = await api.post(CLASS_API_PATH, { name });
        return response.data;
    } catch (error) {
        console.error("Error creating class:", error);
        throw error;
    }
};

export const updateClass = async (classId, classData) => {
    const response = await api.put(`${CLASS_API_PATH}/${classId}`, classData);
    return response.data;
};

export const updateClassDetails = async (classId, classData) => {
    const response = await api.put(`${CLASS_API_PATH}/${classId}/details`, classData);
    return response.data;
};


export const assignTeacherToClass = async (classId, teacherId) => {
    try {
        const response = await api.put(`${CLASS_API_PATH}/${classId}/assign-teacher`, { teacher_id: teacherId });
        return response.data;
    } catch (error) {
        console.error("Error assigning teacher:", error);
        throw error;
    }
};

export const saveAllClassTeacherAssignments = async (assignments) => {
    const response = await api.post(`${CLASS_API_PATH}/assign-teachers`, { assignments });
    return response.data;
};

export const saveAllAttendanceModes = async (modes) => {
    const response = await api.post(`${CLASS_API_PATH}/update-attendance-modes`, { modes });
    return response.data;
};

export const getClassSummary = async (classId) => {
    try {
        const response = await api.get(`${CLASS_API_PATH}/${classId}/summary`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching class summary for class ${classId}:`, error);
        throw error;
    }
};
